/* ------------------------------------------------------------------
// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている

 * チェックボックスのグループに対して、少なくとも1つ選択されるようHTML5のrequired属性を動的に制御する。
 * - 同じname属性を持つチェックボックスを1つのグループとみなす
 * - グループ内で1つ以上チェックされていれば、required属性は解除
 * - 何もチェックされていなければ、グループ内のチェックボックスにrequiredを付与
 * これにより、ユーザーはチェックボックスのグループで必ず1つ以上を選択する必要がある
--------------------------------------------------------------------- */
function enforceAtLeastOneCheckbox() {
  const target_checkboxes = $("input[type=checkbox].jsRequired");
  target_checkboxes.on("change", function () {
    const name = $(this).attr("name");
    const same_group_checks = $(`input[name="${name}"]`);
    const checked_or_not = !!same_group_checks.filter(function () {
      return this.checked;
    }).length;
    if (checked_or_not) {
      same_group_checks.attr("required", false);
    } else {
      same_group_checks.attr("required", true);
    }
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default enforceAtLeastOneCheckbox;